import { render } from "./SectionDownloads.vue?vue&type=template&id=74609682"
import script from "./SectionDownloads.vue?vue&type=script&lang=js"
export * from "./SectionDownloads.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__